import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Steps } from "@/components/Steps";
import { Benefits } from "@/components/Benefits";
import { About } from "@/components/About";
import { Reviews } from "@/components/Reviews";
import { FinalCTA, Footer } from "@/components/FinalCTA";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { CookieBanner } from "@/components/CookieBanner";

const NOISE =
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.55'/%3E%3C/svg%3E";

const Landing = () => (
    <div className="bg-brand-cream dark:bg-brand-night" data-testid="landing-page">
        <div
            aria-hidden="true"
            className="pointer-events-none fixed inset-0 z-[70] opacity-[0.04] mix-blend-overlay"
            style={{ backgroundImage: `url("${NOISE}")` }}
        />
        <Header />
        <main>
            <Hero />
            <Marquee />
            <Steps />
            <Benefits />
            <About />
            <Reviews />
            <FinalCTA />
        </main>
        <Footer />
        <WhatsAppFloat />
        <CookieBanner />
    </div>
);

export default Landing;
